import React from 'react';
import '../../css/index.css';

export default function Circle(props) {
    return <div className='circle' style={{ backgroundColor: props.color }} />;
}